/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateRangeArrayToObject',
  standalone: true,
})
export class DateRangeArrayToObjectPipe implements PipeTransform {
  transform(value: string[], ...args: any[]) {
    if (value && Array.isArray(value)) {
      return {
        startDate: value[0],
        endDate: value[1],
      };
    }

    return null;
  }
}
